
import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { LogIn, LogOut, Settings, User } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { ProfileMenu } from "@/components/auth/ProfileMenu";
import { DropdownMenuContent, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuItem, DropdownMenu } from "@radix-ui/react-dropdown-menu";
import { Link, useNavigate } from 'react-router-dom';
import { useToast } from '@/hooks/use-toast';
interface MobileMenuProps {
  onClose: () => void;
  isAuthenticated
}


export const MobileMenu: React.FC<MobileMenuProps> = ({ onClose , isAuthenticated }) => {
  const { toast } = useToast();
  const navigate = useNavigate();
  const [user, setUser] = useState<any | null>(null);


useEffect(() => {
  const raw = localStorage.getItem('user_session');
  if (raw) {
    try {
      setUser(JSON.parse(raw));
    } catch {
      localStorage.removeItem('user_session');
    }
  }
}, []);
const getDisplayName = () => {
  if (user?.name) return user?.name;
  if (user?.first_name || user?.last_name)
    return `${user?.first_name || ''} ${user?.last_name || ''}`.trim();
  return user?.email;
};

const displayName = getDisplayName();

const handleLogout = () => {
  toast({
    title: 'Logging out',
    description: 'Please wait while we log you out...',
  });

  localStorage.removeItem('user_session');
  navigate('/auth', { replace: true });
};

const getProfileRoute = () => {
  switch (user?.role) {
    case 'doctor': return '/doctor';
    case 'hospital': return '/hospital';
    case 'patient': return '/patient';
    case 'insurance': return '/insurance';
    case 'staff': return '/staff';
    case 'admin': return '/admin';
    default: return '/';
  }
};

  return (
    <div className="fixed inset-0 z-50 bg-white pb-6 px-4 overflow-y-auto" style={{marginTop:'4rem'}}>
      <div className="space-y-4">
      <div className="pt-6 border-t border-gray-200">
        </div>
        <Accordion type="single" collapsible className="w-full">
        <AccordionItem value="account">
            <AccordionTrigger className="text-lg font-medium">
              Account
            </AccordionTrigger>
            <AccordionContent>
            {isAuthenticated ? (
              <div>
                <div className="flex flex-col space-y-1">
                          <p className="text-sm font-medium">{displayName}</p>
                          <p className="text-xs text-muted-foreground">{user?.email}</p>
                        </div>
                        <Link to={getProfileRoute()} className="flex items-center">
                          <User className="mr-2 h-4 w-4" />
                          <span>Profile</span>
                        </Link>
                        <Link to="/settings" className="flex items-center">
                          <Settings className="mr-2 h-4 w-4" />
                          <span>Settings</span>
                        </Link>
                        <div onClick={handleLogout} className="text-red-500 focus:bg-red-50 focus:text-red-600 flex">
                        <LogOut className="mr-2 h-4 w-4" >Log Out </LogOut>
                         <span>Log out</span>
                         </div>
                    
                    
                    </div>
              ) : (
                <Link to="/auth">
                  <Button variant="outline" size="sm" className="ml-4">
                    <LogIn className="h-4 w-4 mr-2" />
                    Sign In
                  </Button>
                </Link>
              )}
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value="providers">
            <AccordionTrigger className="text-lg font-medium">
              For Providers
            </AccordionTrigger>
            <AccordionContent>
              <div className="flex flex-col space-y-3 pl-4 pt-2">
                <Link 
                  to="/doctor" 
                  className="py-2 text-blue-600 hover:text-blue-800"
                  onClick={onClose}
                >
                  Doctor Portal
                </Link>
                <p className="text-sm text-gray-500 pb-2">
                  Access patient records and manage appointments
                </p>
                
                <Link 
                  to="/hospital" 
                  className="py-2 text-blue-600 hover:text-blue-800"
                  onClick={onClose}
                >
                  Hospital Dashboard
                </Link>
                <p className="text-sm text-gray-500 pb-2">
                  Manage hospital resources and patient care
                </p>
              </div>
            </AccordionContent>
          </AccordionItem>
          
          <AccordionItem value="patients">
            <AccordionTrigger className="text-lg font-medium">
              For Patients
            </AccordionTrigger>
            <AccordionContent>
              <div className="flex flex-col space-y-3 pl-4 pt-2">
                <Link 
                  to="/patient" 
                  className="py-2 text-blue-600 hover:text-blue-800"
                  onClick={onClose}
                >
                  Patient Portal
                </Link>
                <p className="text-sm text-gray-500 pb-2">
                  Access your health records and manage appointments
                </p>
                
                <Link 
                  to="/insurance" 
                  className="py-2 text-blue-600 hover:text-blue-800"
                  onClick={onClose}
                >
                  Insurance Coverage
                </Link>
                <p className="text-sm text-gray-500 pb-2">
                  View your coverage details and claims
                </p>
              </div>
            </AccordionContent>
          </AccordionItem>
          
          <AccordionItem value="about">
            <AccordionTrigger className="text-lg font-medium">
              About
            </AccordionTrigger>
            <AccordionContent>
              <div className="flex flex-col space-y-3 pl-4 pt-2">
                <Link 
                  to="/about" 
                  className="py-2 text-blue-600 hover:text-blue-800"
                  onClick={onClose}
                >
                  About Us
                </Link>
                <p className="text-sm text-gray-500 pb-2">
                  Learn about our mission and services
                </p>
                
                <Link 
                  to="/contact" 
                  className="py-2 text-blue-600 hover:text-blue-800"
                  onClick={onClose}
                >
                  Contact Us
                </Link>
                <p className="text-sm text-gray-500 pb-2">
                  Get in touch with our support team
                </p>
              </div>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
    </div>
  );
};

